import { useState } from 'react';
import { useSelector } from 'dva';

/**
 * @description 通过dva useSelector从store.loading.effects里取值的快捷方式
 * @param {string} namespace
 * @param {string[]} paths
 * @returns {boolean}
 */
const useEffectLoading = (namespace: string, paths: string[]) => {
  const [targets] = useState(() => paths.slice());
  return useSelector((_: any) =>
    targets.some((path) => !!_.loading.effects[`${namespace}/${path}`]),
  );
};

export default useEffectLoading;
